$(document).ready(function () {
  // Function to initialize a slider
  function initializeSlider($element, slidesToShow, slidesToScroll) {
    let $slider = $element.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
      infinite: false,
      variableWidth: true,
      prevArrow: $element.parent().find('.custom-prev'),
      nextArrow: $element.parent().find('.custom-next'),
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Event handling logic for disabling/enabling prev/next buttons
    $slider.on('afterChange', function (event, slick, currentSlide) {
      const $prevButton = $element.parent().find('.custom-prev');
      const $nextButton = $element.parent().find('.custom-next');

      // Disable/enable prev button based on current slide index
      if (currentSlide === 0) {
        $prevButton.addClass('disabled');
      } else {
        $prevButton.removeClass('disabled');
      }

      // Disable/enable next button based on current slide index
      if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
        $nextButton.addClass('disabled');
      } else {
        $nextButton.removeClass('disabled');
      }
    });

    // Initial check to disable prev button if at the start
    if ($slider.slick('slickCurrentSlide') === 0) {
      $element.parent().find('.custom-prev').addClass('disabled');
    }
  }

  // Initialize desktop slider
  initializeSlider($('.multiple-items'), 3, 1);

  // Initialize mobile slider
  initializeSlider($('.mobile-multiple-items'), 1.5, 1);
});
